import { __decorate, __param } from 'tslib';
import { DOCUMENT } from '@angular/common';
import { Inject, ElementRef, Renderer2, HostListener, Directive, NgModule } from '@angular/core';
import { containsOrAfter } from '@taiga-ui/cdk/utils/dom';
import { getNativeFocused, setNativeFocused, getClosestFocusable, blurNativeFocused } from '@taiga-ui/cdk/utils/focus';

// @dynamic
import * as ɵngcc0 from '@angular/core';
let TuiFocusTrapDirective = class TuiFocusTrapDirective {
    constructor(documentRef, elementRef, renderer) {
        this.documentRef = documentRef;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.activeElement = getNativeFocused(this.documentRef);
        /**
         * This would cause currently focused element to lose focus
         * but it might cause ExpressionChanged error due to potential HostBinding.
         * Microtask keeps it in the same frame but allows change detection to run
         */
        Promise.resolve().then(() => {
            setNativeFocused(this.elementRef.nativeElement);
        });
    }
    onBlur() {
        this.renderer.removeAttribute(this.elementRef.nativeElement, 'tabIndex');
    }
    onFocusIn(node) {
        if (containsOrAfter(this.elementRef.nativeElement, node)) {
            return;
        }
        const focusable = getClosestFocusable(this.elementRef.nativeElement, false, this.elementRef.nativeElement);
        if (focusable) {
            setNativeFocused(focusable);
        }
    }
    ngOnDestroy() {
        blurNativeFocused(this.documentRef);
        /**
         * HostListeners are triggered even after ngOnDestroy
         * {@link https://github.com/angular/angular/issues/38100}
         * so we need to delay it but stay in the same sync cycle,
         * therefore using Promise instead of setTimeout
         */
        Promise.resolve().then(() => {
            // TODO: iframe warning
            if (this.activeElement instanceof HTMLElement) {
                setNativeFocused(this.activeElement);
            }
        });
    }
};
TuiFocusTrapDirective.ɵfac = function TuiFocusTrapDirective_Factory(t) { return new (t || TuiFocusTrapDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(Renderer2)); };
TuiFocusTrapDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiFocusTrapDirective, selectors: [["", "tuiFocusTrap", ""]], hostAttrs: ["tabIndex", "0"], hostBindings: function TuiFocusTrapDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function TuiFocusTrapDirective_blur_HostBindingHandler() { return ctx.onBlur(); })("focusin.silent", function TuiFocusTrapDirective_focusin_silent_HostBindingHandler($event) { return ctx.onFocusIn($event.target); }, false, ɵngcc0.ɵɵresolveWindow);
    } } });
TuiFocusTrapDirective.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Renderer2, decorators: [{ type: Inject, args: [Renderer2,] }] }
];
__decorate([
    HostListener('blur')
], TuiFocusTrapDirective.prototype, "onBlur", null);
__decorate([
    HostListener('window:focusin.silent', ['$event.target'])
], TuiFocusTrapDirective.prototype, "onFocusIn", null);
TuiFocusTrapDirective = __decorate([ __param(0, Inject(DOCUMENT)),
    __param(1, Inject(ElementRef)),
    __param(2, Inject(Renderer2))
], TuiFocusTrapDirective);

let TuiFocusTrapModule = class TuiFocusTrapModule {
};
TuiFocusTrapModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiFocusTrapModule });
TuiFocusTrapModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiFocusTrapModule_Factory(t) { return new (t || TuiFocusTrapModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiFocusTrapDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiFocusTrap]',
                host: {
                    tabIndex: '0'
                }
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.Renderer2, decorators: [{
                type: Inject,
                args: [Renderer2]
            }] }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur']
        }], onFocusIn: [{
            type: HostListener,
            args: ['window:focusin.silent', ['$event.target']]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiFocusTrapModule, { declarations: [TuiFocusTrapDirective], exports: [TuiFocusTrapDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiFocusTrapModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiFocusTrapDirective],
                exports: [TuiFocusTrapDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFocusTrapDirective, TuiFocusTrapModule };

//# sourceMappingURL=taiga-ui-cdk-directives-focus-trap.js.map